const SECTOR_OVERVIEW = "view-sector";
const SUB_SECTOR_OVERVIEW = "view-sub-sector";
const IMPORT_SECTOR_VIEW = () => {
  return import("@/modules/sectors/_views/SectorView.vue");
};
const IMPORT_EXPERIENCE_LIST = () => {
  return import("@/modules/sectors/_views/SectorExperiences.vue");
};
const IMPORT_ALL_OPPORTUNITIES = () => {
  return import("@/modules/sectors/_views/AllOpportunities.vue");
};
const IMPORT_OPPORTUNITY_VIEW_V2 = () => {
  return import("@/modules/sectors/_views/OpportunityView.vue");
};

export default [
  {
    path: "/sectors",
    name: "sectors",
    redirect: { name: "sector-dashboard" },
  },
  {
    path: "/sectors/dashboard",
    name: "sector-dashboard",
    component: () => import("@/modules/sectors/_views/SectorDashboard.vue"),
    meta: {
      title: "Sectors",
      hasSidebar: true,
    },
  },
  {
    path: "/sectors/opportunities",
    component: () => import("@/modules/sectors/_views/OpportunitiesShell.vue"),
    meta: {
      hasSidebar: true,
    },
    children: [
      {
        path: "",
        name: "sector-opportunities",
        component: IMPORT_ALL_OPPORTUNITIES,
        meta: {
          title: "Sectors // Opportunities",
          pageTitle: "Opportunities",
        },
      },
      {
        path: "add",
        name: "sector-opportunities-add",
        component: () => import("@/modules/sectors/_components/opportunities/OpportunityForm.vue"),
        meta: {
          title: "Sectors // Opportunities // Add",
          pageTitle: "Create Opportunity",
          backButtonRoute: {
            name: "sector-opportunities",
          },
        },
      },
      {
        path: ":opportunityId",
        name: "sector-opportunity-view",
        props: true,
        component: IMPORT_OPPORTUNITY_VIEW_V2,
        meta: {
          title: "Sectors // Opportunities // View",
          pageTitle: "Opportunity",
          backButtonRoute: {
            name: "sector-opportunities",
          },
        },
      },
    ],
  },
  {
    path: "/sectors/:id",
    props: true,
    redirect: { name: SECTOR_OVERVIEW },
    component: () => import("@/modules/sectors/_views/SectorShell.vue"),

    children: [
      {
        path: "overview",
        props: true,
        name: SECTOR_OVERVIEW,
        component: IMPORT_SECTOR_VIEW,
        meta: {
          title: "Sectors // {id}",
          hasSidebar: true,
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: "sector-dashboard",
          },
        },
      },
      {
        path: "clients",
        name: "view-sector-clients",
        component: () => import("@/modules/sectors/_views/SectorClients.vue"),
        meta: {
          title: "Sectors // {id} // Clients",
          hasSidebar: true,
          pageTitle: "Clients",
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "matters",
        name: "view-sector-matters",
        component: () => import("@/modules/sectors/_views/SectorMatters.vue"),
        meta: {
          title: "Sectors // {id} // Matters",
          hasSidebar: true,
          pageTitle: "Matters",
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "people",
        name: "view-sector-people",
        component: () => import("@/modules/sectors/_views/SectorPeople.vue"),
        meta: {
          title: "Sectors // {id} // People",
          hasSidebar: true,
          pageTitle: "People",
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "sub-sector/:subsectorid",
        name: "view-sub-sector",
        props: true,
        component: IMPORT_SECTOR_VIEW,
        meta: {
          title: "Sectors // Sub Sector // {subsectorid}",
          hasSidebar: true,
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "revenue",
        name: "view-sector-revenue",
        component: () => import("@/modules/sectors/_views/SectorRevenue.vue"),
        meta: {
          title: "Sectors // {id} // Revenue",
          hasSidebar: true,
          pageTitle: "Sector Revenue",
          showSlicer: true,
          showFY: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "experiences/list",
        name: "view-sector-experiences",
        component: IMPORT_EXPERIENCE_LIST,
        meta: {
          title: "Sectors // {id} // Experiences",
          pageTitle: "Sector Experience",
          showSlicer: false,
          showFY: true,
          hasSidebar: true,
          isFiltered: true,
          backButtonRoute: {
            name: SECTOR_OVERVIEW,
          },
        },
      },
      {
        path: "sub-sector/:subsectorid/experiences/list",
        name: "view-sub-sector-experiences",
        component: IMPORT_EXPERIENCE_LIST,
        meta: {
          title: "Sub Sector // {subsectorid} // Experiences",
          hasSidebar: true,
          pageTitle: "Experiences",
          showSlicer: false,
          showFY: true,
          backButtonRoute: {
            name: SUB_SECTOR_OVERVIEW,
          },
        },
      },
    ],
  },
  // Additional route for magnolia content
  {
    path: "/sectors/dxp",
    name: "SectorMagnoliaContent",
    component: () =>
      import("@/modules/sectors/_views/SectorMagnoliaContent.vue"),
    meta: {
      title: "Magnolia Content",
      pageTitle: "Magnolia Demo Content",
      hasSidebar: true,
      backButtonRoute: {
        name: SECTOR_OVERVIEW,
      },
    },
  },
];
